/* src/app/pages/login-v2/steps/onboarding-step/onboarding-step.component.scss */
.auth-onboarding__intro,
.auth-onboarding__question {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.auth-onboarding__subtitle {
  margin: 0;
  color: var(--text-default);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.auth-onboarding__options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.auth-onboarding__option {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  color: var(--text-default);
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}
.auth-onboarding__actions {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
:host ::ng-deep .auth-onboarding__option .p-radiobutton,
:host ::ng-deep .auth-onboarding__option .p-checkbox {
  flex-shrink: 0;
}
/*# sourceMappingURL=onboarding-step.component.css.map */
